

// Import jQUery Validation components as needed
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jquery-ajax-unobtrusive';

const helpers = require.context('./Helpers', true, /\.(js)$/);
helpers.keys().forEach(helpers);

const common = require.context('./Common', true, /\.(js)$/);
common.keys().forEach(common);

const components = require.context('../Components', true, /\.(js)$/);
components.keys().forEach(components);
 
import './lib/outline.js';

var tables = document.querySelectorAll('.text table');
tables.forEach(table => {
    var container = document.createElement('div');
    container.classList.add('table-container');
    container.wrap(table);
});

$(document).ready(function () {
    InitLoadEvents.init();
});